import { ModuleWithProviders, NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { TranslateModule } from "@ngx-translate/core";
import { CoreModule } from "@obg/ngx.core";

import { ContentSectionEffect } from "./content-section/content-section.effect";
import { FlagEffect } from "./flag/flag.effect";
import { IconEffect } from "./icon/icon.effect";
import { ImageEffect } from "./image/image.effect";
import { MenuEffect } from "./menu/menu.effect";
import { MessageCodeFallbackPipe } from "./message-code-fallback/message-code-fallback.pipe";
import { QuicklinkEffect } from "./quicklink/quicklink.effect";
import { TranslationEffect } from "./translation/translation.effect";

const CORE_CONTENT_EFFECTS = [
	ImageEffect,
	MenuEffect,
	FlagEffect,
	TranslationEffect,
	QuicklinkEffect,
	ContentSectionEffect,
	IconEffect,
];

@NgModule({
	imports: [TranslateModule, CoreModule, EffectsModule.forFeature(CORE_CONTENT_EFFECTS)],
	declarations: [MessageCodeFallbackPipe],
	exports: [MessageCodeFallbackPipe, TranslateModule],
})
export class CoreContentModule {
	static forRoot(): ModuleWithProviders<CoreContentModule> {
		return {
			ngModule: CoreContentModule,
		};
	}
}
